import {UIConfig} from "../UIConfig";


const UI_CONFIGS = new Map<UIConfig, string>();

UI_CONFIGS.set(UIConfig.available_subjects_filter_group, 'BSCI');

export {UI_CONFIGS};

